import React, { useEffect } from "react";

import { Form, Formik } from "formik";
import * as Yup from "yup";
import Swal from "sweetalert2";

import { registerLocale, setDefaultLocale } from "react-datepicker";
import { isAfter, isBefore, parse, isValid } from "date-fns";
import "react-datepicker/dist/react-datepicker.css";
import pt from "date-fns/locale/pt-BR";

import {
  Flex,
  Button,
  SimpleGrid,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  Input,
} from "@chakra-ui/react";

import { CustomDatepickerWField } from "../../../../../components/CustomDatepickerWField";

import EquipeSAService from "../../../../../../main/services/EquipeSAService";

const DesligarModal = ({
  isOpen,
  onOpen,
  onClose,
  id,
  inicioAtividade,
  handleMembroDesligado,
  setLoadingPainel,
}) => {
  useEffect(() => {
    setDefaultLocale("pt-br");
    registerLocale("pt-br", pt);
  }, []);

  const schema = Yup.object().shape({
    dataDesligamento: Yup.string("Este campo é obrigatório!")
      .required("Este campo é obrigatório!")
      .test("validDate", "Data inválida!", (value) => {
        if (!!value) {
          if (value.length === 10) {
            return isValid(parse(value, "dd/MM/yyyy", new Date()));
          } else {
            return false;
          }
        } else {
          return false;
        }
      })
      .test(
        "dataDesligamentoAfterToday",
        "A data informada não pode ser uma data futura!",
        (value) => {
          if (!Boolean(value)) {
            return false;
          } else {
            return !isAfter(parse(value, "dd/MM/yyyy", new Date()), new Date());
          }
        }
      )
      .test(
        "dataDesligamentoBeforeInicio",
        "A data informada não pode ser anterior a data de início das atividades!",
        (value) => {
          if (!Boolean(value)) {
            return false;
          } else {
            if (isValid(inicioAtividade)) {
              return !isBefore(
                parse(value, "dd/MM/yyyy", new Date()),
                new Date(inicioAtividade)
              );
            } else {
              return !isBefore(
                parse(value, "dd/MM/yyyy", new Date()),
                parse(inicioAtividade, "dd/MM/yyyy", new Date())
              );
            }
          }
        }
      ),
  });

  const handleSubmit = (values, actions) => {
    const { dataDesligamento } = values;
    const dataDesligamentoSend = dataDesligamento
      ? parse(dataDesligamento, "dd/MM/yyyy", new Date()).toISOString()
      : "";

    setTimeout(() => {
      EquipeSAService.desligarMembroSA(id, dataDesligamentoSend)
        .then((res) => {
          setLoadingPainel(true);
          Swal.fire({
            title: "Sucesso!",
            text: "Membro desligado com sucesso!",
            icon: "success",
            confirmButtonText: "Continuar",
            confirmButtonColor: "#169499",
          }).then(function () {
            handleMembroDesligado();
          });
          actions.setSubmitting(false);
        })
        .catch((error) => {
          if (error.response) {
            if (error.response.data) {
              if (error.response.data.message) {
                const errors = JSON.parse(error.response.data.message);
                for (let key in errors) {
                  actions.setFieldError(key.toString(), errors[key]);
                }
              } else if (error.response.data.apierror) {
                if (error.response.data.apierror.subErrors) {
                  error.response.data.apierror.subErrors.forEach((erro) => {
                    actions.setFieldError(erro.field, erro.message);
                  });
                }
              }
            }
          } else {
            console.log(error);
          }
          actions.setSubmitting(false);
        });
    }, 200);
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="md">
      <ModalOverlay />
      <ModalContent p="25px" w={{ base: "100%", lg: "70%" }} bgColor="#FFF">
        <ModalHeader
          p="0px"
          fontWeight={700}
          fontSize="14px"
          lineHeight="19.6px"
          color="#95BCBF"
        >
          {"Desligar membro da equipe do Serviço".toUpperCase()}
        </ModalHeader>
        <ModalBody p="0px" mt="25px">
          <Formik
            validationSchema={schema}
            initialValues={{
              dataDesligamento: "",
            }}
            onSubmit={handleSubmit}
            validateOnChange={false}
            validateOnBlur={false}
          >
            {(props) => (
              <Form>
                <Flex flexDir="column">
                  <Input
                    type="text"
                    opacity={0}
                    position="absolute"
                    zIndex="-1"
                    tabIndex={0}
                  />
                  <CustomDatepickerWField
                    fieldName="dataDesligamento"
                    label="Data do Desligamento*"
                    placeholder="DD/MM/AAAA"
                  />
                  <SimpleGrid
                    alignSelf="center"
                    mt="40px"
                    columns={2}
                    spacing="20px"
                    w={"80%"}
                  >
                    <Button
                      color="#FFF"
                      backgroundColor="#169499"
                      fontWeight={700}
                      fontSize="15px"
                      lineHeight="21.6px"
                      _hover={{ bg: "#169499" }}
                      onClick={onClose}
                    >
                      Cancelar
                    </Button>
                    <Button
                      type="submit"
                      translate="no"
                      color="#FFF"
                      backgroundColor="#169499"
                      fontWeight={700}
                      fontSize="15px"
                      lineHeight="21.6px"
                      _hover={{ bg: "#169499" }}
                      isLoading={props.isSubmitting}
                    >
                      Desligar
                    </Button>
                  </SimpleGrid>
                </Flex>
              </Form>
            )}
          </Formik>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default DesligarModal;
